import { cn } from '@lib/tw';
import {
  Select as Select_,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/ui/select';

type Option<L extends string, V extends string> = {
  [key in L]: React.ReactNode;
} & {
  [key in V]: string;
};

type Props<V extends string, L extends string, Item extends Option<L, V>> = {
  className?: string;
  id?: string;
  name?: string;
  valueKey: V;
  displayTextKey: L;
  onChange?(value: Item[V]): void;
  selectedValue?: Item[V];
  options: Array<Item>;
  disabled?: boolean;
  defaultValue?: string;
  value?: string;
};

export const Select = <
  V extends string,
  L extends string,
  Item extends Option<L, V>,
>(
  props: Props<V, L, Item>
) => {
  const { options, onChange, disabled, defaultValue, selectedValue } = props;
  const { displayTextKey, valueKey } = props;

  const selected = options.find(
    (item) => item[valueKey] === (selectedValue || defaultValue)
  );

  return (
    <Select_
      name={props.name}
      onValueChange={onChange}
      defaultValue={selected?.[displayTextKey] || null}
      disabled={disabled}
    >
      <SelectTrigger
        id={props.id}
        className={cn('w-[180px]', props.className)}
        disabled={props.disabled}
      >
        <SelectValue>{selected?.[displayTextKey] || null}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {options.map((item) => {
          const label = item[displayTextKey];
          return (
            <SelectItem
              className="text-base"
              key={item[valueKey]}
              value={item[valueKey]}
            >
              {label}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select_>
  );
};
